import React from 'react';
import { Input, Badge, ListGroup, ListGroupItem } from 'reactstrap';

const DualListPanel = ({
  title,
  titleClassName = 'border rounded p-2 bg-light text-center mb-2 fw-medium fs-12',
  items,
  selectedIds,
  searchValue,
  onSearchChange,
  onSelectionChange,
  lastIndex,
  onLastIndexChange,
  emptyMessage,
}) => {
  const handleItemClick = (e, item, idx) => {
    const id = String(item.id);
    const isSelected = selectedIds.includes(id);

    if (e.shiftKey && lastIndex !== null) {
      const start = Math.min(lastIndex, idx);
      const end = Math.max(lastIndex, idx);
      const rangeIds = items.slice(start, end + 1).map(x => String(x.id));
      onSelectionChange(Array.from(new Set([...selectedIds, ...rangeIds])));
    } else if (e.ctrlKey || e.metaKey) {
      onSelectionChange(
        isSelected ? selectedIds.filter(i => i !== id) : [...selectedIds, id]
      );
    } else {
      onSelectionChange(isSelected && selectedIds.length === 1 ? [] : [id]);
    }

    onLastIndexChange(idx);
  };

  return (
    <>
      <div className={titleClassName}>
        {title} ({items.length})
      </div>
      <div className='search-box mb-2'>
        <Input
          type='text'
          className='form-control form-control-sm'
          placeholder='Search menu...'
          value={searchValue}
          onChange={e => onSearchChange(e.target.value)}
        />
        <i className='ri-search-line search-icon'></i>
      </div>
      <ListGroup
        flush
        style={{ height: '300px', overflowY: 'auto' }}
        className='border rounded'
      >
        {items.length === 0 ? (
          <ListGroupItem className='text-center text-muted fs-12 py-3'>
            {emptyMessage}
          </ListGroupItem>
        ) : (
          items.map((m, idx) => {
            const id = String(m.id);
            const isSelected = selectedIds.includes(id);
            return (
              <ListGroupItem
                key={m.id}
                active={isSelected}
                onClick={e => handleItemClick(e, m, idx)}
                className='d-flex justify-content-between align-items-center py-2 px-3'
                style={{ cursor: 'pointer', userSelect: 'none' }}
              >
                <div className='d-flex align-items-center gap-2'>
                  {m.isHeader ? (
                    <i className='ri-folder-line text-warning'></i>
                  ) : (
                    <i className='ri-menu-line text-muted'></i>
                  )}
                  <span className={m.isHeader ? 'fw-semibold' : ''}>
                    {m.label || m.name || m.id}
                  </span>
                </div>
                {m.isHeader && (
                  <Badge color='warning' className='fs-10 rounded-pill'>
                    Header
                  </Badge>
                )}
              </ListGroupItem>
            );
          })
        )}
      </ListGroup>
    </>
  );
};

export default DualListPanel;
